module.exports = __webpack_public_path__ + "img/icon-wifi-1.17fd4ed0.svg";